import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const ExplainerVideoStyles = styled.div`
  .default-video-container {
    width: 100%;
    padding: 8px 8px 0 8px;
    border-radius: 8px;
    background: ${theme.primaryColours.white.main};

    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      display: grid;
      grid-template-columns: 1fr 1fr;
      margin: 0 auto;
      grid-gap: 24px;
      padding: 8px;
      width: ${theme.grid.resolution.tablet.container}px;
    }

    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      width: ${theme.grid.resolution.desktop.container}px;
    }
  }

  .explainer-video-mobile {
    position: fixed;
    top: 48px;
    left: 48px;
    bottom: 48px;
    right: 48px;
    width: calc(100% - 96px);
    height: calc(100% - 96px);
  }

  .dismiss-wrapper-mobile {
    position: fixed;
    top: ${theme.grid.spacing.base}px;
    right: 24px;
    width: 18px;
    height: 18px;
    cursor: pointer;
    z-index: 25;
    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      top: ${theme.grid.spacing.l}px;
      right: ${theme.grid.spacing.l}px;
    }
    svg {
      width: 18px;
      height: 18px;
    }
  }

  .overlay-wrapper {
    max-width: 750px;
    max-height: 500px;
    width: 95%;
    padding: 0;

    .explainer-video {
      width: 100%;
      height: 100%;
    }

    .dismiss-wrapper {
      top: 23px;
      right: 23px;
    }

    .content-wrapper {
      height: 410px;
      @media (min-width: ${theme.grid.resolution.desktop.width}px) {
        height: 422px;
      }
    }
  }
`
